export const LOW_DETRACTOR_SEGMENT_ID = 1
export const HIGH_DETRACTOR_SEGMENT_ID = 3
